(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino/quick-transaction/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/casino/quick-transaction/assets/javascripts/prescript.js');
"use strict";


svs = svs || {};
svs.casino = svs.casino || {};
svs.casino.quick_transaction = svs.casino.quick_transaction || {};

 })(window);